export const checkMinLength = (password: string): boolean => {
  return password.length >= 8;
};
export const containsUpperCase = (password: string): boolean => {
  return password.toLowerCase() != password;
};
export const containsLowerCase = (password: string): boolean => {
  return password.toUpperCase() != password;
};
export const containsSpecialCharacter = (password: string): boolean => {
  return password.match(/([\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-])/) ? true : false;
};
export const containsNumber = (password: string): boolean => {
  return password.match(/[0-9]/) ? true : false;
};
export function getSpecialCharsList() {
  return "^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ ` = + -";
}
